import React, { useState } from "react";
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { useTheme } from "styled-components";
import { LinkInternal } from "./LinkInternal";
import { Button } from "./Button";

const CookieConsentBanner = (): JSX.Element => {
  const theme = useTheme();

  const [cookieBannerVisible, setCookieBannerVisible] = useState(true);

  const hasGoogleAnalyticsCookie = getCookieConsentValue(
    "gatsby-gdpr-google-analytics"
  );

  const onDeclineCookies = () => {
    setCookieBannerVisible(false);
  };

  const isDevelopmentEnvironment =
    process.env.GATSBY_ENVIRONMENT === "Development";

  return (
    <>
      {!hasGoogleAnalyticsCookie && cookieBannerVisible && (
        <CookieConsent
          // set debug true for development, remove for produciton.
          debug={isDevelopmentEnvironment}
          onAccept={() => {
            console.log("Accepted GA cookie");
          }}
          location="bottom"
          // expires prop sent how long the cookie is valid for in days. Once accepted, the banner won't display for this duration.
          expires={365}
          cookieName="gatsby-gdpr-google-analytics"
          buttonText="Ok great!"
          declineButtonText="Decline"
          style={{
            color: theme.colours.foreground,
            background: theme.colours.background,
            left: "initial",
            right: "0",
            maxWidth: "400px",
            fontSize: "18px",
            textAlign: "center",
            alignItems: "center",
            justifyContent: "center",
            borderTopLeftRadius: theme.borderRadius.image,
            borderTop: `1px solid ${theme.colours.lightGrey}`,
            borderLeft: `1px solid ${theme.colours.lightGrey}`,
            // borderTopRightRadius: theme.borderRadius.image,
          }}
          buttonStyle={{
            color: theme.colours.background,
            background: theme.colours.foreground,
            fontSize: "18px",
            padding: "10px 15px",
            borderRadius: theme.borderRadius.button,
            marginTop: "0",
          }}
        >
          This site uses cookies.
          <br /> See our{" "}
          <LinkInternal to="/privacy" tabIndex={0}>
            privacy policy{" "}
          </LinkInternal>
          for more.
          <Button
            onClick={onDeclineCookies}
            style={{
              border: "0",
              boxShadow: "none",
              padding: "5px",
              position: "absolute",
              top: "10px",
              right: "10px",
            }}
          >
            <FontAwesomeIcon
              icon={faTimesCircle}
              style={{
                ...closeIconStyles,
                color: theme.colours.foreground,
              }}
            />
          </Button>
        </CookieConsent>
      )}
    </>
  );
};
const closeIconStyles = {
  width: "1rem",
  height: "1rem",
  maxWidth: "40px",
  maxHeight: "40px",
};

export default CookieConsentBanner;
